import UISelect from 'UIComponents/input/UISelect';
import EditorRelatedConditionsHeadingAssociationSelectValueComponent from '../editor/EditorRelatedConditionsHeadingAssociationSelectValueComponent';
import getIn from 'transmute/getIn';
import { useStrategy } from '../../hooks/useStrategy';
import { getAssociationOption, getAssociationOptionByValue, getAssociationInfoFromAssociationValue } from '../../utils/associatedRecordsUtils';
import { ASSOCIATION_DIRECTION } from '../../filterQueryFormat/associations/AssociationUtilities';
import { jsx as _jsx } from "react/jsx-runtime";
const AssociationLabelSelect = ({
  associatedObjectTypeId,
  associationCategory,
  associationInverseId,
  onAssociationValueChange
}) => {
  const {
    getObjectInverseAssociationOptions
  } = useStrategy();
  const associationOptions = getObjectInverseAssociationOptions(associatedObjectTypeId);
  const associationOption = getAssociationOption(associationOptions, associationInverseId, associationCategory, ASSOCIATION_DIRECTION.INVERSE);
  const onChange = evt => {
    const newAssociationValue = evt.target.value;
    const newAssociationOption = getAssociationOptionByValue(associationOptions, newAssociationValue);
    const {
      associationCategory: newAssociationCategory
    } = getAssociationInfoFromAssociationValue(newAssociationOption === null || newAssociationOption === void 0 ? void 0 : newAssociationOption.value);
    onAssociationValueChange(newAssociationOption === null || newAssociationOption === void 0 ? void 0 : newAssociationOption.inverseId, newAssociationCategory);
  };
  return /*#__PURE__*/_jsx(UISelect, {
    className: "m-left-0 m-top-2",
    onChange: onChange
    //@ts-expect-error wrong options type
    ,
    options: associationOptions,
    value: associationOption && associationOption.value || getIn([0, 'value'], associationOptions),
    valueComponent: EditorRelatedConditionsHeadingAssociationSelectValueComponent
  });
};
export default AssociationLabelSelect;